import * as React from 'react';
import { Input, IconSearch16, InputAdornment } from '@cian/ui-kit';
import * as style from './FakeSearchInput.css';

export interface IFakeSearchInputProps {
  placeholder: string;
  onClick: () => void;
  value?: string;
}

export const FakeSearchInput: React.FC<IFakeSearchInputProps> = props => {
  const { placeholder, value, onClick } = props;

  const handleKeyPress = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (onClick && ['Enter', 'Space'].includes(event.code)) {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <div className={style['container']} onClick={onClick} onKeyPress={handleKeyPress} role="button" tabIndex={0}>
      <div className={style['input']}>
        <Input
          tabIndex={-1}
          size="M"
          placeholder={placeholder}
          value={value}
          leftAdornment={
            <InputAdornment>
              <IconSearch16 />
            </InputAdornment>
          }
        />
      </div>
    </div>
  );
};
